export default __webpack_public_path__ + "static/media/2356.6a04abba.png";